import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, mergeMap, Observable, of, throwError } from 'rxjs';

import { EnvironmentService, ErableHttpService, ReturnType } from '@ecm/consumer';
import { ErrorPageService } from '@ecm/router';
import { KenobiParams, Status } from '@ecm/tracker';

import { ContractExclusion } from '../business/api/contract/contractExclusion';
import { KenobiTrackingCode } from '../business/model/tracking/kenobiTrackingCode-model';
import { TrackingService } from './tracking.service';

@Injectable({
    providedIn: 'root',
})
export class RhocService {
    public constructor(
        private readonly httpErable: ErableHttpService,
        private readonly errorService: ErrorPageService,
        private readonly environmentService: EnvironmentService,
        private readonly trackingService: TrackingService,
    ) {}

    public requestInitRhoc(cid: string, kenobiTrackingCode: KenobiTrackingCode, pageId: string): Observable<any> {
        const env = this.environmentService.instant();
        if (env.API.DASHBOARD.CONTRACT_EXCLUSION_URL) {
            return this.httpErable
                .get(env.API.DASHBOARD.CONTRACT_EXCLUSION_URL + '/' + cid, {
                    returnType: ReturnType.HTTP_RESPONSE,
                    headers: this.getCustomHeaders(),
                    feature: 'dashboard',
                    pageId,
                    functionality: kenobiTrackingCode['functionality'],
                    partner: 'ZGP',
                    service: 'simulateContractExclusion',
                })
                .pipe(
                    mergeMap((response: HttpResponse<any>) => {
                        return of(response.status === 204 ? [] : response.body);
                    }),
                    catchError(() => {
                        this.trackingService.trackKenobi(
                            new KenobiParams(
                                kenobiTrackingCode['functionality'],
                                kenobiTrackingCode['rubric'],
                                Status.KOSI,
                            ),
                            pageId,
                        );
                        this.errorService.showDefaultErrorPage();
                        throw new Error('Rhoc Service is on error');
                    }),
                );
        } else {
            this.errorService.showDefaultErrorPage();
            return throwError(() => 'Rhoc Service is not activated');
        }
    }

    public getRhoc(
        cid: string,
        kenobiTrackingCode: KenobiTrackingCode,
        pageId: string,
    ): Observable<ContractExclusion[]> {
        return this.requestInitRhoc(cid, kenobiTrackingCode, pageId);
    }

    private getCustomHeaders(): HttpHeaders {
        return new HttpHeaders().set('Accept', 'application/json;version=1');
    }
}
